module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addCurrency
    }
  }, [_vm._v("添加货币")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "货币名称，例子：RMB"
    },
    model: {
      value: (_vm.params.currency),
      callback: function($$v) {
        _vm.$set(_vm.params, "currency", $$v)
      },
      expression: "params.currency"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.dataSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.currencyList,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "货币名称(全名)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currency",
      "label": "货币名称(缩写)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "symbol",
      "label": "货币符号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate",
      "label": "货币汇率"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_default",
      "label": "是否为默认"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": (scope.row.is_default) ? true : false
          },
          on: {
            "change": function($event) {
              return _vm.setDefault(scope.row)
            }
          },
          model: {
            value: (scope.row.is_default),
            callback: function($$v) {
              _vm.$set(scope.row, "is_default", $$v)
            },
            expression: "scope.row.is_default"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (!scope.row.is_default) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "rules": _vm.rules,
        "label-width": "220px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "货币名称（中文全名）",
        "prop": "title"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "货币名称（中文全名），例子：中国人民币"
      },
      model: {
        value: (_vm.form.title),
        callback: function($$v) {
          _vm.$set(_vm.form, "title", $$v)
        },
        expression: "form.title"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "货币名称（英文缩写）",
        "prop": "currency"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "货币名称（英文缩写），例子：RMB"
      },
      model: {
        value: (_vm.form.currency),
        callback: function($$v) {
          _vm.$set(_vm.form, "currency", $$v)
        },
        expression: "form.currency"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "货币符号",
        "prop": "symbol"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "￥"
      },
      model: {
        value: (_vm.form.symbol),
        callback: function($$v) {
          _vm.$set(_vm.form, "symbol", $$v)
        },
        expression: "form.symbol"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "货币汇率",
        "prop": "rate"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-input', {
      attrs: {
        "required": "",
        "placeholder": "1"
      },
      model: {
        value: (_vm.form.rate),
        callback: function($$v) {
          _vm.$set(_vm.form, "rate", $$v)
        },
        expression: "form.rate"
      }
    })], 1), _vm._v(" "), (_vm.form.rate && _vm.form.title) ? _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("1 " + _vm._s(_vm.form.title) + "(" + _vm._s(_vm.form.symbol) + ") = " + _vm._s(_vm.form.rate) + " 人民币(￥)")]) : (_vm.form.rate && _vm.form.currency) ? _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("1 " + _vm._s(_vm.form.currency) + " = " + _vm._s(_vm.form.rate) + " RMB")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "适用端",
        "prop": "rate"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "normal",
        "value": "normal"
      },
      model: {
        value: (_vm.form.use_platform),
        callback: function($$v) {
          _vm.$set(_vm.form, "use_platform", $$v)
        },
        expression: "form.use_platform"
      }
    }, [_vm._v("实体类商城")])], 1)], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-99fff022", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99fff022"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/currency/index.vue
// module id = 2886
// module chunks = 0